module.exports = __webpack_public_path__ + "static/media/chocopiedras-confiteria-lara-composiccion-nutricional.3bf31a08.pdf";